/**
 * Bring a tapped search field to near the top of the screen on a phone, so its
 * dropdown has room below it. Relative to where the field is: the phone search
 * forms used to scroll to a fixed 250/350px, which on Design B's home (the form
 * sits under a full-screen banner) threw the page back to the top.
 */
export const scrollFieldIntoView = (el: HTMLElement, headroom = 120) => {
  window.scrollTo({ top: window.scrollY + el.getBoundingClientRect().top - headroom, behavior: "smooth" });
};
